/* istanbul ignore file */
import { useSelector } from 'react-redux';
import { selectedTeamSelector } from 'state/selectors/ui-state';
import { TEAM_TYPES } from 'common/constants/constants';
import {
  isTeamLicenseSelector,
  licenseSelector
} from 'state/selectors/license';

const useDoraFeatureFlags = () => {
  const selectedTeam = useSelector(selectedTeamSelector);
  const isTeamLicense = useSelector(isTeamLicenseSelector);
  const license = useSelector(licenseSelector) || {};

  const isAllControbutorsTeamSelected =
    selectedTeam?.type === TEAM_TYPES.ALL_CONTRIBUTORS;

  const { isPaid, isTrial } = license;
  const isFreePlan = !isPaid && !isTrial;

  return {
    isAllControbutorsTeamSelected,
    isFreePlan,
    enableTeamSelection: isAllControbutorsTeamSelected ? !isTeamLicense : true,
    showTeamGoals: isAllControbutorsTeamSelected ? !isTeamLicense : true
  };
};

export default useDoraFeatureFlags;
